export default __webpack_public_path__ + "images/A5.64f8d61.png";